import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import Button from 'components/form/Button';
import Card from 'components/Layout/Card';
import Loader from 'components/Layout/Loader';
import Profile from 'components/Layout/Profile';
import { agendaPath, icons, profilePath } from 'utils/constants';
import { addMyInterestSessions, getSession } from 'store/slices';
import {
  downloadFile,
  formatDate,
  generatePreSignedUrl,
  getDataFromLocalStorage,
  getEventDate,
  objectToFormData,
} from 'utils/helpers';
import SessionForm from '../SessionForm';
import './SessionDetails.scss';
import Accordion from 'react-bootstrap/Accordion';

const SessionDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const { memberType, moduleType, sessionId: paramsSessionId } = params;
  const [isLoading, setLoading] = useState(true);
  const [session, setSession] = useState({});
  const [sessionId, setSessionId] = useState('');
  const fetchSessionDetails = async () => {
    const response = await dispatch(getSession(paramsSessionId));
    let data = {};
    if (response?.data) {
      data = response.data;
    }
    setSession(data);
    setLoading(false);
  };
  const handelAddEditMyInterest = async () => {
    const oldData = cloneDeep(session);
    const response = await dispatch(
      addMyInterestSessions(
        objectToFormData({
          user_id: getDataFromLocalStorage('id'),
          session_id: oldData.id,
        })
      )
    );
    if (response?.status === 200) {
      setSession({
        ...oldData,
        is_interested: oldData.is_interested === 0 ? 1 : 0,
      });
    }
  };

  useEffect(() => {
    fetchSessionDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    session_time,

    session_end_time,
    name,
    presenter_profile,
    description,
    is_interested,
    speaker_details,
    transcription,
    date,
    session_topic,
    event_name,
    event_start_date,
    event_end_date,
    event_city,
    event_county,
    speaker_category,
  } = session;

  const eventData = {};

  const userType = getDataFromLocalStorage('user_type');
  const access = {
    isAdmin: userType === '0',
  };

  const formatSessionTime = (session_time, session_end_time) => {
    const start = moment(session_time, 'HH:mm:ss').format('h:mma');
    const end = session_end_time
      ? moment(session_end_time, 'HH:mm:ss').format('h:mma')
      : null;

    if (end) {
      return `${start} - ${end}`;
    } else {
      return start;
    }
  };

  const [s3URL, setS3URL] = useState('');
  const fetchProfile = async (profileName) => {
    let retunURL = '';
    const response = await generatePreSignedUrl(profileName, profilePath);
    retunURL = response;
    setS3URL(retunURL);
  };
  useEffect(() => {
    if (speaker_details?.length > 0 && speaker_details[0].photo) {
      fetchProfile(
        speaker_category === 9 ? presenter_profile : speaker_details[0]?.photo
      );
    } else if (speaker_details?.length > 0) {
      setS3URL(
        (speaker_category === 9
          ? presenter_profile
          : speaker_details[0]?.photo) || ''
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [speaker_details]);
  return (
    <div id="session-details-container">
      {sessionId && (
        <SessionForm
          handelSuccess={fetchSessionDetails}
          onHide={() => {
            setSessionId('');
          }}
          sessionId={sessionId}
        />
      )}
      {isLoading ? (
        <Card className="cpt-80 cpb-80">
          <Loader size="md" />
        </Card>
      ) : (
        <>
          <Card className="unset-br cpe-26 cps-26 pt-4 pb-4 fadeInUp">
            <div className="w-100 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <span
                  className="d-flex"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <img
                    src={icons.leftArrow}
                    alt="back"
                    className="h-21 me-4 pointer"
                  />
                </span>
                <div className="color-black-olive text-16-400">
                  <i
                    className={`bi bi-star${
                      is_interested ? '-fill' : ''
                    } me-2 pointer`}
                    onClick={() => {
                      handelAddEditMyInterest();
                    }}
                  />
                  Interested
                </div>
              </div>
              {access.isAdmin && (
                <Button
                  onClick={() => {
                    setSessionId(+paramsSessionId);
                  }}
                  text="Edit"
                  btnStyle="light-outline"
                  className="h-35 text-14-500 cps-20 cpe-20"
                  icon={<i className="bi bi-pencil me-2" />}
                  isSquare
                />
              )}
            </div>
          </Card>

          <div className="agenda-single-card fadeInUp">
            <div className="agenda-heading">{event_name}</div>
            <div>
              <div className="card-detail">
                <img src={icons.calendarEvent} alt="Icon" />
                <span>{getEventDate(event_start_date, event_end_date)}</span>
              </div>
              <div className="card-detail">
                <img src={icons.locationEvent} alt="Icon" />
                <span>
                  {event_city}, {event_county}
                </span>
              </div>
            </div>
          </div>

          <div className="session-fulldetail fadeInUp">
            <div className="session-card">
              <div className="session-img">
                <img src={s3URL || icons.userImg} alt="Image" />
              </div>
              <div className="session-detail">
                {speaker_category === 9 ? (
                  <div className="text-16-400-20 cmb-17 color-new-car">
                    {name}
                  </div>
                ) : (
                  <a
                    href={`/${memberType}/${moduleType}/speaker/${speaker_details?.[0]?.id}`}
                    className="user-name"
                  >
                    {speaker_details?.[0]?.name}
                  </a>
                )}

                <p className="session-topic">{session_topic}</p>
                <div>
                  <div>
                    <img src={icons.calendarEvent} alt="Icon" />
                    <span>{formatDate(date)}</span>
                  </div>
                  |
                  <div>
                    <img src={icons.clockEvent} alt="Icon" />
                    <span>
                      {formatSessionTime(session_time, session_end_time)}
                    </span>
                  </div>
                  |
                  <div>
                    <img src={icons.locationEvent} alt="Icon" />
                    <span>
                      {event_city}, {event_county}
                    </span>
                  </div>
                </div>
                <p className="session-name">
                  {speaker_category === 9 ? speaker_details[0]?.name : name}
                </p>
              </div>
            </div>

            <Accordion defaultActiveKey={['0']} alwaysOpen>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div>
                    <div>
                      <img src={icons.calendarEvent} alt="Icon" />
                      <span>{formatDate(date)}</span>
                    </div>
                    <div>
                      <img src={icons.clockEvent} alt="Icon" />
                      <span>
                        {formatSessionTime(session_time, session_end_time)}
                      </span>
                    </div>
                    <div>
                      <img src={icons.locationEvent} alt="Icon" />
                      <span>
                        {' '}
                        {event_city}, {event_county}
                      </span>
                    </div>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <h5>{session_topic}</h5>
                  <p>{description}</p>
                </Accordion.Body>
              </Accordion.Item>
              {/* <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div>
                    <div>
                      <img src={icons.calendarEvent} alt="Icon" />
                      <span>27-July-2024</span>
                    </div>
                    <div>
                      <img src={icons.clockEvent} alt="Icon" />
                      <span>5pm - 6:30am</span>
                    </div>
                    <div>
                      <img src={icons.locationEvent} alt="Icon" />
                      <span>1st floor, Marina Hall, Singapore</span>
                    </div>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <h5>
                    Opening keynote: Uniting higher education, governments,
                    industry and society for a sustainable future
                  </h5>
                  <p>
                    Education technology has experienced exponential growth in
                    recent years. However, the speed at which it has been
                    developed and embedded into learning environments has meant
                    that more in-depth research and development approaches were
                    often neglected. This oversight has led to cost
                    inefficiencies, low impact and even exacerbated gaps in
                    equity of access to education. This panel will highlight how
                    research and innovation stakeholders are evolving to align
                    their practices to generate tangible improvements in
                    education outcomes for all.
                  </p>
                  <ul>
                    <li>
                      How are different stakeholders employing innovative tools
                      such as big data and analytics to identify and close gaps
                      in education access? Can these approaches be improved and,
                      if so, how?
                    </li>
                    <li>
                      How should research communities and solution providers
                      develop practices and approaches to address gender-based
                      barriers to equitable education access?
                    </li>
                    <li>
                      How can education providers work with researchers and
                      solution providers to drive evidence-based innovations
                      that can be meaningfully embedded into teaching and
                      learning?
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item> */}
            </Accordion>
          </div>
        </>
      )}
    </div>
  );
};
export default SessionDetails;

// import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";
// import { cloneDeep } from "lodash";
// import moment from "moment";
// import Button from "components/form/Button";
// import Card from "components/Layout/Card";
// import Loader from "components/Layout/Loader";
// import Profile from "components/Layout/Profile";
// import { agendaPath, icons } from "utils/constants";
// import { addMyInterestSessions, getSession } from "store/slices";
// import {
//   downloadFile,
//   generatePreSignedUrl,
//   getDataFromLocalStorage,
//   objectToFormData,
// } from "utils/helpers";
// import SessionForm from "../SessionForm";
// import "./SessionDetails.scss";

// const SessionDetails = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const params = useParams();
//   const { memberType, moduleType, sessionId: paramsSessionId } = params;
//   const [isLoading, setLoading] = useState(true);
//   const [session, setSession] = useState({});
//   const [sessionId, setSessionId] = useState("");
//   const fetchSessionDetails = async () => {
//     const response = await dispatch(getSession(paramsSessionId));
//     let data = {};
//     if (response?.data) {
//       data = response.data;
//     }
//     setSession(data);
//     setLoading(false);
//   };
//   const handelAddEditMyInterest = async () => {
//     const oldData = cloneDeep(session);
//     const response = await dispatch(
//       addMyInterestSessions(
//         objectToFormData({
//           user_id: getDataFromLocalStorage("id"),
//           session_id: oldData.id,
//         })
//       )
//     );
//     if (response?.status === 200) {
//       setSession({
//         ...oldData,
//         is_interested: oldData.is_interested === 0 ? 1 : 0,
//       });
//     }
//   };

//   useEffect(() => {
//     fetchSessionDetails();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const {
//     session_time,
//     name,
//     description,
//     is_interested,
//     speaker_details,
//     transcription,
//   } = session;

//   const userType = getDataFromLocalStorage("user_type");
//   const access = {
//     isAdmin: userType === "0",
//   };

//   return (
//     <div id="session-details-container">
//       {sessionId && (
//         <SessionForm
//           handelSuccess={fetchSessionDetails}
//           onHide={() => {
//             setSessionId("");
//           }}
//           sessionId={sessionId}
//         />
//       )}
//       {isLoading ? (
//         <Card className="cpt-80 cpb-80">
//           <Loader size="md" />
//         </Card>
//       ) : (
//         <>
//           <Card className="unset-br cpe-26 cps-26 pt-4 pb-4 fadeInUp">
//             <div className="w-100 d-flex align-items-center justify-content-between">
//               <div className="d-flex align-items-center">
//                 <span
//                   className="d-flex"
//                   onClick={() => {
//                     navigate(-1);
//                   }}
//                 >
//                   <img
//                     src={icons.leftArrow}
//                     alt="back"
//                     className="h-21 me-4 pointer"
//                   />
//                 </span>
//                 <div className="color-black-olive text-16-400">
//                   <i
//                     className={`bi bi-star${
//                       is_interested ? "-fill" : ""
//                     } me-2 pointer`}
//                     onClick={() => {
//                       handelAddEditMyInterest();
//                     }}
//                   />
//                   Interested
//                 </div>
//                 {/* {!access.isAdmin && (
//                   <>
//                     <div className="vr ms-3 me-3" />
//                     <div className="color-black-olive text-16-400 pointer">
//                       <i className="bi bi-share me-2" />
//                       Share
//                     </div>
//                   </>
//                 )} */}
//               </div>
//               {access.isAdmin && (
//                 <Button
//                   onClick={() => {
//                     setSessionId(+paramsSessionId);
//                   }}
//                   text="Edit"
//                   btnStyle="light-outline"
//                   className="h-35 text-14-500 cps-20 cpe-20"
//                   icon={<i className="bi bi-pencil me-2" />}
//                   isSquare
//                 />
//               )}
//             </div>
//             <div className="color-black-olive text-14-400 cmt-30 cmb-26">
//               {moment(session_time, "hh:mm:ss").format("hh:mm a")}
//             </div>
//             <div className="color-raisin-black text-22-500 cmb-16">{name}</div>
//             <div className="color-black-olive text-14-400 mb-3">
//               {description}
//             </div>
//             <div
//               className="color-new-car text-14-400 pointer"
//               onClick={async () => {
//                 const res = await generatePreSignedUrl(
//                   transcription,
//                   agendaPath
//                 );
//                 dispatch(downloadFile(res));
//               }}
//             >
//               <u>Please click here to view the transcription</u>
//             </div>
//           </Card>
//           <Card className="unset-br cpe-26 cps-26 pt-5 pb-4 mt-3 fadeInUp">
//             <div className="color-raisin-black text-20-500">Speakers</div>
//             <div className="d-flex">
//               {speaker_details &&
//                 speaker_details.map((elem, index) => {
//                   return (
//                     <div
//                       className="committee-members-card-container col-md-3 cmb-20"
//                       key={index}
//                     >
//                       <div
//                         className="shadow-block pointer"
//                         onClick={() => {
//                           navigate(
//                             `/${memberType}/${moduleType}/speaker/${elem.id}`
//                           );
//                         }}
//                       >
//                         <div className="image-block center-flex">
//                           <Profile
//                             isS3UserURL
//                             text={elem.name}
//                             url={elem.photo}
//                             size="s-163"
//                           />
//                         </div>
//                         <div className="text-16-600 color-new-car cmt-20 pointer">
//                           {elem.name}
//                         </div>
//                         <div className="text-16-500 color-black-olive cmt-12">
//                           {elem.designation}
//                         </div>
//                         <div className="text-16-400 color-black-olive cmt-12">
//                           {elem.institution}
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//             </div>
//           </Card>
//         </>
//       )}
//     </div>
//   );
// };
// export default SessionDetails;
